import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO15 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK001-5.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO15
